import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const fade = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
  transition: { duration: 0.25 },
};

export const AddOnsStep = ({ visibleAddons, selectedAddons, setSelectedAddons }) => (
  <motion.div
    key="s4"
    {...fade}
    className="bg-white rounded-2xl p-6 shadow-sm border border-zinc-100"
    data-testid="step-addons"
  >
    <h2 className="text-lg sm:text-xl font-bold text-zinc-900 font-heading mb-1">
      Enhance Your Clean
    </h2>
    <p className="text-sm text-zinc-500 mb-5">
      Optional add-ons for a truly thorough experience
    </p>

    <div className="space-y-3">
      {visibleAddons.map((addon) => {
        const isOn = selectedAddons.includes(addon.id);
        return (
          <button
            key={addon.id}
            onClick={() =>
              setSelectedAddons((p) => (isOn ? p.filter((a) => a !== addon.id) : [...p, addon.id]))
            }
            className={`w-full p-4 rounded-xl border-2 flex items-center justify-between transition-all ${
              isOn ? 'border-[#F56F05] bg-[#FFF7ED]' : 'border-zinc-100 hover:border-[#F56F05]/40'
            }`}
            data-testid={`addon-${addon.id}`}
          >
            <div className="flex items-center gap-3">
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                  isOn ? 'bg-[#F56F05] text-white' : 'bg-zinc-100 text-zinc-400'
                }`}
              >
                <addon.icon className="h-4 w-4" />
              </div>
              <span className="font-semibold text-zinc-900 text-sm">{addon.name}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-bold text-zinc-700 text-sm">+${addon.price}</span>
              <div
                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
                  isOn ? 'border-[#F56F05] bg-[#F56F05] text-white' : 'border-zinc-300'
                }`}
              >
                {isOn && <Check className="h-3.5 w-3.5" />}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  </motion.div>
);
